import React, { useLayoutEffect } from 'react';
import "../Css/Rooms.css";
import "../Component/NavBar/Header";
import RoomFilter from '../Component/Rooms/RoomFilter';
import Footer from "../Component/Footer/Footer";
import { MetaTags } from 'react-meta-tags';

const Rooms = () => {
    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    });
    return (
        <>
 <MetaTags>
                        <title>Resort With Rooms In Neral | Seema Resort</title>
                        <meta title="Resort With Rooms In Neral | Seema Resort" />
                        <meta name="description" content="Seema Resort offers a relaxing getaway with comfortable accommodations and scenic views, making it the perfect Resort with Rooms in Neral." />
                        <meta name="keywords" content="Best Resort in Mahabaleshwar, Top Resort with Rooms in Mahabaleshwar, Resort with Valley View in Mahabaleshwar, Resort with Premium Rooms in Mahabaleshwar, Best 3BHK Villa in Mahabaleshwar, Premium Villa in Mahabaleshwar, Family Resort in Mahabaleshwar, Resort near Mahabaleshwar" />
                        <link rel="canonical" href="https://seemasresort.com/resort-with-rooms-neral" />
                        <meta http-equiv="cache-control" content="no-cache" />
                        <meta http-equiv="expires" content="0" />
                        <meta http-equiv="pragma" content="no-cache" />
                        <meta property="og:title" content=" Resort With Rooms In Neral | Seema Resort" />
                        <meta property="og:locale" content="en_US" />
                        <meta property="og:type" content="website" />
                        <meta property="og:url" content="https://seemasresort.com/" />
                        <meta property="og:description" content="Seema Resort offers a relaxing getaway with comfortable accommodations and scenic views, making it the perfect Resort with Rooms in Neral." />
                        <meta property="og:image" content="https://seemasresort.com/static/media/logo.png" />
                      </MetaTags>
            {/* <MetaTags>
                <title>Top Resort with Rooms in Mahabaleshwar | Royal Resort</title>
                <meta title="Top Resort with Rooms in Mahabaleshwar | Royal Resort" />
                <meta name="description" content="Stay at the top resort in Mahabaleshwar, offering luxurious rooms, serene surroundings, and premium amenities. Perfect for a relaxing. Book now!." />
                <meta name="keywords" content="Best Resort in Mahabaleshwar, Top Resort with Rooms in Mahabaleshwar, Resort with Valley View in Mahabaleshwar, Resort with Premium Rooms in Mahabaleshwar, Best 3BHK Villa in Mahabaleshwar, Premium Villa in Mahabaleshwar, Family Resort in Mahabaleshwar, Resort near Mahabaleshwar" />
                <link rel="canonical" href="https://suryasparadise.com/resort-valley-view-mahabaleshwar" />
                <meta http-equiv="cache-control" content="no-cache" />
                <meta http-equiv="expires" content="0" />
                <meta http-equiv="pragma" content="no-cache" />
                <meta property="og:title" content=" Top Resort with Rooms in Mahabaleshwar | Royal Resort" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://suryasparadise.com/" />
                <meta property="og:description" content="Stay at the top resort in Mahabaleshwar, offering luxurious rooms, serene surroundings, and premium amenities. Perfect for a relaxing. Book now!" />
                <meta property="og:image" content="https://suryasparadise.com/static/media/logo.png" />
            </MetaTags> */}

            <section className='Rooms-Section-Banner-List-Images'>
                <div className='Rooms-Section-Banner-Images-con'>
                    {/* <h1>Top Resort with Rooms in Mahabaleshwar</h1> */}
                    <h2 className='mt-5 ms-5'>Rooms</h2>

                </div>
            </section>
            <div className="container mt-4 my-2 ">
<h1 className="text-start heading" style={{fontFamily:" var(---lato)"}}>Resort With Rooms In Neral </h1>
</div>
            {/* <BannerBar /> */}
            <RoomFilter />
            <div className='py-5 my-5 container-fluid' style={{backgroundColor:"#254222",color:"#ece2b1",display:"none"}}>
            <div className='container  lead' style={{textAlign:'justify'}}>
                <p >
                    At Seema Resort, we offer a range of beautifully designed rooms that provide the perfect blend of luxury, comfort, and tranquillity. Our resort features spacious and well-appointed accommodations, ensuring a relaxing stay for all our guests. Whether you're visiting for a romantic getaway, a family vacation, or a corporate retreat, our rooms cater to all your needs.
                </p>
                <p >
                As a Resort with Rooms in Neral, we take pride in offering a variety of room types that suit different preferences and budgets. From elegantly furnished deluxe rooms to cosy cottages, each of our rooms is designed to provide a peaceful haven. Every room is equipped with modern amenities, including air conditioning, high-speed internet, comfortable bedding, and more, to ensure a memorable stay.
                </p>
                <p >
                Our rooms are thoughtfully designed to offer both privacy and comfort. Each one features scenic views of the surrounding nature, allowing you to connect with the tranquillity of the area. Whether you're waking up to a serene sunrise or enjoying a peaceful evening, the beauty of Neral will always be within reach.
                </p>
                <p >
                Seema Resort is proud to be known as a Resort with Rooms in Neral that focuses on offering guests a luxurious experience. We believe that a great vacation begins with a great room, and our rooms reflect our commitment to providing exceptional hospitality.
                </p>
                <p >
                From spacious rooms with cosy interiors to private cottages, we offer accommodation options for every type of traveller. Our attention to detail, along with our focus on comfort, makes Seema Resort the ideal destination for those seeking a relaxing and rejuvenating stay.
                </p>
                <p >
                When you choose Seema Resort, you're not just choosing a place to stay – you're choosing an experience. Book your stay with us today and discover the comfort and luxury of our Resort with Rooms in Neral.
                </p>

            </div>
            </div>
            <Footer />
        </>
    )
}

export default Rooms